import { PlusOutlined } from '@ant-design/icons';
import {
  BasketballPracticeTimesScheduleOverviewTeam,
  PracticeTimesScheduleEntry,
} from '@hefe/models';
import styles from './practice-times-schedule-overview-new-time.module.scss';

interface PracticeTimesScheduleOverviewNewTimeProps {
  team: BasketballPracticeTimesScheduleOverviewTeam;
  dayOfWeek: number;
  disableEditing?: boolean;
  onOpenSettings?: (
    teamId: number,
    practiceTime: PracticeTimesScheduleEntry | undefined,
    dayOfWeek: number
  ) => void;
}

export default function PracticeTimesScheduleOverviewNewTime(
  props: PracticeTimesScheduleOverviewNewTimeProps
) {
  const { team, dayOfWeek, disableEditing, onOpenSettings } = props;

  const openPracticeTimeSettings = () => {
    const practiceTime = {
      weekday: dayOfWeek,
      basketball_teams: [
        {
          id: team.id,
          name: team.name,
        },
      ],
    } as PracticeTimesScheduleEntry;

    onOpenSettings?.(team.id, practiceTime, dayOfWeek);
  };

  return (
    <div
      onClick={() => {
        if (!disableEditing) {
          openPracticeTimeSettings();
        }
      }}
      className={!disableEditing ? styles['time'] : undefined}
      style={{ cursor: !disableEditing ? 'pointer' : 'default' }}
    >
      <div className={styles['icon-container']}>
        <PlusOutlined />
      </div>
    </div>
  );
}
